import React from 'react'

import ProdutoSelector from 'entity/Produto/components/ProdutoSelector';

export default function PainelProdutos({ rodada }) {
  return (
    <>
      <ProdutoSelector
        name="produtos"
        label="Produtos"
        permiteEditarDescricao
        exibeLimpar
      />

    </>
  )
}
